import { Component, input, output, signal, computed } from '@angular/core';
import { IVerticalMenuItem, VERTICAL_MENU_SEPARATOR_ITEM } from '../vertical-menu-item';

@Component({
	selector: 'nr-vertical-menu-item',
	styleUrl: './vertical-menu-item.component.scss',
	standalone: false,
	template: `
		@if (item().children != null && item().children.length > 0) {
			<div
				ngbDropdown
				[placement]="item().placement || 'auto'"
				class="vertical-item"
				[class.active]="this.isDropdownOpen()"
				(openChange)="onDropdownToggle($event)">
				<button
					ngbDropdownToggle
					class="dropright"
					placement="right"
					container="body"
					tooltipClass="nr-tooltip"
					[openDelay]="700"
					#t="ngbTooltip"
					(click)="t.close()"
					[ngbTooltip]="item().title ? (item().title | translate) : ''">
					@if (item().iconClass) {
						<i [ngClass]="item().iconClass"></i>
					}
					<!-- @if (item().text) {
						<span>{{ item().text | translate }}</span>
					} -->
				</button>
				<div
					ngbDropdownMenu
					class="vertical-item-menu">
					@for (child of item().children; track $index) {
						@if (child.id !== this.VERTICAL_MENU_SEPARATOR_ITEM.id) {
							<div
								[id]="child.id"
								ngbDropdownItem
								placement="right"
								container="body"
								tooltipClass="nr-tooltip"
								[openDelay]="700"
								[ngbTooltip]="child.title ? (child.title | translate) : ''"
								#t="ngbTooltip"
								(click)="t.close(); onItemClick(child)">
								@if (child.iconClass) {
									<i [ngClass]="child.iconClass"></i>
								}
								@if (child.text) {
									<span>{{ child.text | translate }}</span>
								}
							</div>
						} @else {
							<hr class="separator" />
						}
					}
				</div>
			</div>
		} @else {
			@if (item().id !== this.VERTICAL_MENU_SEPARATOR_ITEM.id) {
				<div class="vertical-item">
					<button
						placement="right"
						container="body"
						tooltipClass="nr-tooltip"
						[openDelay]="700"
						[ngbTooltip]="item().title ? (item().title | translate) : ''"
						#t="ngbTooltip"
						(click)="t.close(); onItemClick(item())">
						@if (item().iconClass) {
							<i [ngClass]="item().iconClass"></i>
						}
						<!-- @if (item().text) {
							<span>{{ item().text | translate }}</span>
						} -->
					</button>
				</div>
			} @else {
				<hr class="separator-main" />
			}
		}
	`,
})
export class VerticalMenuItemComponent {

	public VERTICAL_MENU_SEPARATOR_ITEM = VERTICAL_MENU_SEPARATOR_ITEM;

	public item = input<IVerticalMenuItem>();
	public clicked = output<IVerticalMenuItem>();
	// Track if dropdown is open (for items with children)
	private isDropdownOpen = signal(false);

	// Method to handle item click
	public onItemClick(item: IVerticalMenuItem): void {
		this.clicked.emit(item);
	}

	// Method to handle dropdown toggle
	public onDropdownToggle(isOpen: boolean): void {
		this.isDropdownOpen.set(isOpen);
	}

	// Method to reset active state (can be called from parent)
	public resetActive(): void {
		this.isDropdownOpen.set(false);
	}
}
